import { createFileRoute, notFound } from "@tanstack/react-router";
import { DateTime } from "luxon";
//
import { z } from "zod";
import { zodValidator } from "@tanstack/zod-adapter";
// UI
import { PlayerInsightsPage } from "@src/pages/player-insights/player-insights-page";
import { RouterLoadingComponent } from "@components/router-loading-component";
// query
import { retrievePlayerActivityQueryOpts } from "@src/services/apiQueries/players";
import { queryClient } from "@config/tanstack/tanstackQuery";

const schema = z.object({
  startDate: z
    .string()
    .date()
    .catch(DateTime.local().startOf("week").toFormat("yyyy-MM-dd")),
  endDate: z
    .string()
    .date()
    .catch(DateTime.local().endOf("week").toFormat("yyyy-MM-dd")),
  granularity: z
    .union([z.literal("day"), z.literal("week"), z.literal("month")])
    .catch("day"),
});

export const Route = createFileRoute(
  "/_authenticated/app/players/$playerId/insights",
)({
  component: PlayerInsightsPage,
  validateSearch: zodValidator(schema),
  loader: async (ctx) => {
    const playerId = parseInt(ctx.params.playerId);
    if (isNaN(playerId)) {
      throw notFound();
    }
    const data = await queryClient.ensureQueryData(
      retrievePlayerActivityQueryOpts(playerId, {}),
    );
    return {
      playerActivityResp: data,
    };
  },
  pendingComponent: RouterLoadingComponent,
});
